import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';

import {
    Box, Flex, Image, Text, Button
} from 'components/ui';
import { Container } from 'components/ui';
import ProfileDisplay from 'components/CreatorStoreFront/ProfileDisplay';
import RecServiceCarousel from 'components/RecServiceCarousel';
import ConstructorCarousel from 'components/ConstructorCarousel';

import localeUtils from 'utils/LanguageLocale';
import { CONSTRUCTOR_PODS, GROUPING } from 'constants/constructorConstants';

function CSFContentEmpty({ pathname }) {
    const getText = localeUtils.getLocaleResourceFile('components/CreatorStoreFront/CSFContentEmpty/locales', 'CSFContentEmpty');
    const CarouselComponent = Sephora.configurationSettings.recsMigration?.isEnabled ? RecServiceCarousel : ConstructorCarousel;

    return (
        <div id='csf_empty_content_error_wrapper'>
            <ProfileDisplay
                pathName={pathname}
                displayCommissionableLinks={false}
            />
            <Box
                paddingTop={[6, null, 5]}
                paddingX='container'
                marginX={'auto'}
                maxWidth={375}
            >
                <Flex
                    flexDirection='column'
                    alignItems='center'
                    gap={5}
                    marginBottom={7}
                >
                    <Image
                        src='/img/ufe/loveless.svg'
                        display='block'
                        size={110}
                        disableLazyLoad={true}
                    />
                    <Text
                        is='p'
                        lineHeight='18px'
                        textAlign='center'
                    >
                        {getText('description')}
                    </Text>
                    <Button
                        variant='primary'
                        href='/'
                        children={getText('ctaText')}
                    />
                </Flex>
            </Box>
            <Container>
                <CarouselComponent
                    marginTop={7}
                    marginBottom={[4, null, 6]}
                    titleMarginBottom={[4, null, 5]}
                    podId={CONSTRUCTOR_PODS.CREATOR_STOREFRONT}
                    grouping={GROUPING.CREATOR_STOREFRONT}
                />
            </Container>
        </div>
    );
}

export default wrapFunctionalComponent(CSFContentEmpty, 'CSFContentEmpty');
